import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { API } from "./constant";

export const baseQuery = fetchBaseQuery({
  baseUrl: API.baseUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = JSON.parse(localStorage.getItem("user"))?.userToken;
    if (!headers.has("Authorization") && token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryVendor = fetchBaseQuery({
  baseUrl: API.vendorBase,
  prepareHeaders: (headers, { getState }) => {
    const token = JSON.parse(localStorage.getItem("user"))?.userToken;
    if (!headers.has("Authorization") && token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryNlpc = fetchBaseQuery({
  baseUrl: API.nlpc,
  prepareHeaders: (headers, { getState }) => {
    const token = JSON.parse(localStorage.getItem("user"))?.userToken;
    if (!headers.has("Authorization") && token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryHr = fetchBaseQuery({
  baseUrl: API.hrServices,
  prepareHeaders: (headers, { getState }) => {
    const token = JSON.parse(localStorage.getItem("user"))?.userToken;
    if (!headers.has("Authorization") && token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});
export const baseQueryHrLive = fetchBaseQuery({
  baseUrl: API.liveHRBase,
  prepareHeaders: (headers, { getState }) => {
    const token = JSON.parse(localStorage.getItem("user"))?.userToken;
    if (!headers.has("Authorization") && token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryDocument = fetchBaseQuery({
  baseUrl: API.documentService,
  prepareHeaders: (headers, { getState }) => {
    //   const token = getState().login.token;
    const token = JSON.parse(localStorage.getItem("user"))?.userToken;
    if (!headers.has("Authorization") && token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryControl = fetchBaseQuery({
  baseUrl: API.controlService,
  prepareHeaders: (headers, { getState }) => {
    //   const token = getState().login.token;
    const token = JSON.parse(localStorage.getItem("user"))?.userToken;
    if (!headers.has("Authorization") && token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});
